import React from 'react';
import PlacementCustomCard from 'src/components/customCard/PlacementCustomCard';
import RecuiterCustomCard from 'src/components/customCard/RecuiterCustomCard';

import { HiringFlowType } from 'types';
import { HiringFlowScreen } from 'src/pages/newRecruiterFlow/DrivePrototype';
import { useSearchParams } from 'react-router-dom';

interface Props {
	setHiringFlowScreen: (screen: HiringFlowScreen) => void;
}

const BenchmarkPipeline = ({ setHiringFlowScreen }: Props) => {
	const [searchParams, setSearchParams] = useSearchParams();

	let benchmarkData: {
		title: string;
		description: string;
		imageSrc: string;
		path?: string;
	} = {
		title: 'Benchmark Pipeline',
		description: 'Assess and benchmark your candidates for FREE',
		imageSrc: '/assets/recruiterImages/benchmarkPipeline.svg',
		path: '/benchmarking/create-hiring-assessment',
	};

	let cardData: {
		key: HiringFlowType;
		status: string;
		imageSrc: string;
		description: string;
		path: string;
		disabled?: boolean;
		pending?: string;
		// onBack?: () => void;
	}[] = [
		{
			key: 'benchmark',
			status: 'Benchmark Candidates',
			imageSrc: '/assets/recruiterImages/benchmarkCandidates.svg',
			description: 'Send assessment tests in one go',
			path: '/benchmarking/create-hiring-assessment',
		},
		{
			key: 'connect-with-ATS',
			status: 'Connect with ATS',
			imageSrc: '/assets/recruiterImages/benchmarkATS.svg',
			description: 'Integrate  with ATS & hire',
			path: '/create-new-hiring/freshers-hiring/lateral-hiring',
			disabled: true,
			pending: 'Coming Soon',
		},
	];
	return (
		<div className="flex flex-col md:flex-row gap-[15px] md:gap-[78px] items-center mt-[50px] md:max-w-[1440px] mx-auto">
			<div>
				<PlacementCustomCard
					title={benchmarkData.title}
					description={benchmarkData.description}
					imageSrc={benchmarkData.imageSrc}
				/>
			</div>
			{/* drives */}
			<div className="flex flex-row gap-[10px] overflow-x-auto w-[91%] mx-auto md:mx-0 md:!max-w-[60%]">
				{cardData.map((card, index) => (
					<RecuiterCustomCard
						key={index}
						status={card.status}
						imageSrc={card.imageSrc}
						description={card.description}
						disabled={card.disabled ?? false}
						pending={card.pending ?? ''}
						onClick={() => {
							if (card.key === 'benchmark') {
								setHiringFlowScreen(HiringFlowScreen.SELECT_BENCHMARK_PIPELINE);
							} else if (card.key === 'connect-with-ATS') {
								setHiringFlowScreen(HiringFlowScreen.SELECT_CONNECT_WITH_ATS);
							}
							const newSearchParams = new URLSearchParams(searchParams);
							newSearchParams.set('hiringFlowType', card.key);
							setSearchParams(newSearchParams);
						}}
					/>
				))}
			</div>
			{/* swiper */}
			{/* <div></div> */}
		</div>
	);
};

export default BenchmarkPipeline;
